export const NOTIFICACIONES_REQUEST = 'NOTIFICACIONES_REQUEST'
export const NOTIFICACIONES_SUCCESS = 'NOTIFICACIONES_SUCCESS'
export const NOTIFICACIONES_ERROR = 'NOTIFICACIONES_ERROR'

export const NOTIFICACION_READ = 'NOTIFICACION_READ'